import {
    Sun, Zap, Battery, BatteryCharging, Home, Car, Cable, Wrench, Package, Building2, Tag,
    PlugZap, Plug, Clock, Cpu, Gauge, Settings, Server, Fingerprint, Thermometer,
    Lightbulb, Speaker, Fan, Shield, Cloud, Droplets, CircuitBoard, Box, Anchor, Landmark,
    Wifi, Network, CreditCard, Eye, AlertTriangle, Briefcase, Folder, FileText,
    MonitorSmartphone, Layers, Power, Hash
} from "lucide-react";

const ICONS = {
    Sun, Zap, Battery, BatteryCharging, Home, Car, Cable, Wrench, Package, Building2, Tag,
    PlugZap, Plug, Clock, Cpu, Gauge, Settings, Server, Fingerprint, Thermometer,
    Lightbulb, Speaker, Fan, Shield, Cloud, Droplets, CircuitBoard, Box, Anchor, Landmark,
    Wifi, Network, CreditCard, Eye, AlertTriangle, Briefcase, Folder, FileText,
    MonitorSmartphone, Layers, Power, Hash,
};

// Aliases for DB icon names that map to available icons
const ALIASES = {
    SunDim: Sun, PcCase: Server, BrainCircuit: Cpu, CloudSun: Cloud,
    Ruler: Wrench, RulerIcon: Wrench, Nut: Settings, Grip: Wrench,
    LayoutDashboard: Building2, PuzzlePiece: Package,
};

export function getIcon(name) {
    return ICONS[name] || ALIASES[name] || Tag;
}

export const ICON_NAMES = Object.keys(ICONS);
